<div class="route-component">
    <div class="search-component">
        <h4>Access Denied</h4>

        <p>You are not authenticated, please log in to the site.</p>
    </div>
</div>